import gql from 'graphql-tag';
import React from 'react';
import { Text } from '../../components';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_ROUTES = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: RoutePageFilter
	) {
		getRoutes(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
				defaultStartLocation {
					id
					name
				}
				defaultEndLocation {
					id
					name
				}
				warehouse {
					id
					name
				}
				returnWarehouse {
					id
					name
				}
			}
			count
		}
	}
`;

const RouteSelector = (props) => {

	const { query } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_ROUTES}
			renderItem={item => <Text>{ item.name }</Text>}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select route"
			{...props}
		/>
	);
};

export default RouteSelector;
